/**
 * 缴费订单相关api
 *
 * @param http
 * @returns {{pushError2DingTalk(*): *, modifyPassword(*): *, queryAll(*): *}|*}
 */
export default (http) => {
    return {
        queryByPage (data){
            return http.json({
                url: '/order/query',
                data
            })
        },

        list (data){
            return http.json({
                url: '/order/backList',
                data
            })
        },
        /**
         * 保存信息
         * @param data
         * @returns {*}
         */
        saveInfo(data) {
            return http.json({
                url: '/order/save',
                data
            })
        },
        /**
         * 获取详情
         * @param data
         * @return {*}
         */
        getInfo(data) {
            return http.json({
                url: `/order/get?id=${data.id}`
            })
        },
        /**
         * 删除
         * @param data
         * @returns {*}
         */
        removeInfo(data) {
            return http.json({
                url: `/order/delete?id=${data[0].id}`,
                data
            })
        }
    }
}



// WEBPACK FOOTER //
// ./src/configure/http/api/payorder.js